import { RequestContext } from '../../types/request-context';
import { StringMap, Link, DVString } from './shared';
import { SettingsContent, SettingsContentTypes } from './settings';

export interface GetViewingRestrictionsOutput extends SettingsContent {}

export interface ViewingRestrictionsWidgetTeen extends GetViewingRestrictionsOutput {
    __type: SettingsContentTypes.ViewingRestrictionsWidgetTeen;
    strings: StringMap;
}

export interface ViewingRestrictionsWidgetPinNotSet extends GetViewingRestrictionsOutput {
    __type: SettingsContentTypes.ViewingRestrictionsWidgetPinNotSet;
    strings: StringMap;
    noPinWebViewMessage?: DVString
}

export interface ViewingRestrictionsWidgetStandard extends GetViewingRestrictionsOutput {
    __type: SettingsContentTypes.ViewingRestrictionsWidgetStandard;
    header: string;
    explanation: string;
    ratings: RatingView[];
    allDevicesChecked: boolean;
    devices: DeviceView[];
    strings: StringMap;
    links: StringMap;
    token: string;
}

export interface RatingView {
    name: string;
    description?: string;
    ratingName: string;
    status: RatingStatus;
    available: boolean;
    verifyAge?: Link;
}

export enum RatingStatus {
    Restricted = 'restricted',
    Allowed = 'allowed',
    Max = 'max',
}

export interface DeviceView {
    deviceKey: string;
    displayText: string;
    restricted: boolean;
    multipleDevices: string[];
}


// SetViewingRestrictions
export interface SetViewingRestrictionsInput {
    context: RequestContext;
    token: string;
    maxAllowedRating: string;
    // mutatedDevices is either
    //  - a JSON string with format of MutatedDevices (when request is made from clientside to Gurupa /api/setViewingRestrictions);
    //  or
    //  - a MutatedDevices object (when request is made from DevServer/WidgetServer to WPS directly)
    mutatedDevices?: string | MutatedDevices;
    allDevices?: string[];
    allCheckedDevices?: string[];
}

export interface MutatedDevices {
    checked: string[];
    unchecked: string[];
}

export interface SetViewingRestrictionsOutput {
    success: boolean;
    message: string;
    explanation?: string;
    returnUrl: string;
}
